import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { ActionPalette, BrandPalette, GrayscalePalette } from '@tcl-boron-colors/colors';

export const defaultCommonToggleInputOverrideClasses = {
  disabled: '',
  icon: '',
  input: '',
  label: '',
};

export const checkboxStyles: (
  data?: {
    isSelected: boolean;
    disabled: boolean;
  } & {
    theme?: Jss.Theme;
  },
) => Classes<'svg' | 'checkboxContainer' | 'hoverCheck'> = createUseStyles({
  checkboxContainer: {
    height: '16px',
    width: '16px',
    backgroundColor: ({ isSelected, disabled }: { isSelected: boolean; disabled: boolean }) =>
      isSelected && disabled
        ? GrayscalePalette[400]
        : isSelected && !disabled
        ? ActionPalette[600]
        : GrayscalePalette[100],
    border: '1px solid',
    borderColor: ({ isSelected, disabled }: { isSelected: boolean; disabled: boolean }) =>
      disabled ? GrayscalePalette[400] : isSelected ? ActionPalette[600] : GrayscalePalette[500],
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
    transition: 'borderColor 150ms ease-out, backgroundColor 150ms ease-out',
    boxSizing: 'border-box',
  },
  svg: {
    height: '12px',
    width: '12px',
    display: 'block',
    margin: 'auto !important',
    '& path': {
      stroke: 'white',
      strokeWidth: '.3',
      fill: ({ disabled }: { isSelected: boolean; disabled: boolean }) => (disabled ? 'white' : ''),
      strokeDasharray: 48,
      strokeDashoffset: 48,
      animation: ({ disabled }: { isSelected: boolean; disabled: boolean }) =>
        disabled ? '' : 'stroke .3s ease-out 150ms forwards',
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) ': {
        fill: 'white',
      },
    },
    '& rect': {
      stroke: 'white',
      strokeWidth: '.3',
      fill: ({ disabled }: { isSelected: boolean; disabled: boolean }) => (disabled ? 'white' : ''),
      strokeDasharray: 48,
      strokeDashoffset: 48,
      animation: ({ disabled }: { isSelected: boolean; disabled: boolean }) =>
        disabled ? '' : 'stroke .3s ease-out 150ms forwards',
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) ': {
        fill: 'white',
      },
    },
  },
  hoverCheck: {
    height: '12px',
    width: '12px',
    '& path': {
      fill: BrandPalette[700],
    },
  },
});
